import SnackBar from "components/SnackBar";
import { AlertsProps } from "components/Alerts/data/Alerts.type";

interface SnackbarAlertProps {
  success: AlertsProps;
  handleCloseSnackBar: (state: AlertsProps) => void;
}

/**
 * SnackbarAlert component displays a snackbar notification with a message, severity, and a close handler.
 *
 * @param {SnackbarAlertProps} props - The props for the SnackbarAlert component.
 * @param {Object} props.success - The state of the snackbar.
 * @param {boolean} props.success.show - Determines if the snackbar is visible.
 * @param {string} props.success.message - The message to display in the snackbar.
 * @param {string} props.success.severity - The severity level of the snackbar (e.g., "info", "success", "error", etc.).
 * @param {Function} props.handleCloseSnackBar - Callback function to handle closing the snackbar.
 * @returns {JSX.Element} The rendered SnackbarAlert component.
 */
const SnackbarAlert = ({ success, handleCloseSnackBar }: SnackbarAlertProps) => {
  return (
    <SnackBar
      show={success.show}
      message={success.message}
      severity={success.severity}
      onclose={() =>
        handleCloseSnackBar({ show: false, severity: "info", message: "" })
      }
    />
  );
};

export default SnackbarAlert;
